import { useMemo } from "react";
import useChartSelections from "components/charting/hooks/useChartSelections";

// An unselected measure is kept as a placeholder with a null id, so checking the array length isn't enough.
function useChartMeasureSelected(): boolean {
  const { measures } = useChartSelections();
  return useMemo(() => measures.some((measure) => Boolean(measure?.id)), [measures]);
}

export default useChartMeasureSelected;
